export default {
  namespaced: true,
  state: {
    winners: null,
  },
  actions: {
    // eslint-disable-next-line camelcase
    GetWinners({ commit, rootGetters, dispatch }, profile_id) {
      commit('setField', { name: 'winners', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('profiles/api/v3/winners', { profile_id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'winners', value: response.data.winners });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreWinners({ commit }) {
      commit('setField', { name: 'winners', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
